





















import { Component, Vue } from 'vue-property-decorator'
import { login, getCode, resetPwd } from '@/apis/user'
import { Base64 } from '@/utils/common'
import { isMobile, isEmail, isPassword } from '@/utils/validate'
import { Toast } from 'vant'
let clearInter: any
@Component({
  name: 'Login'
})
export default class extends Vue {
  private form1 = { mobilePhone: '', verificationCode: '', newpassword: '' }
  private totalTime = 120
  private codeCont = ''
  private currCode = ''
  private codeContent = '获取验证码'
  private isCheckBtnDisable = false
  private countDown () {
    // 这里解决60秒不见了的问题
    this.isCheckBtnDisable = true
    this.codeContent = this.totalTime + '重新发送'
    clearInter = window.setInterval(() => {
      this.totalTime--
      this.codeContent = this.totalTime + '重新发送'
      // 当倒计时小于0时清除定时器
      if (this.totalTime < 0) {
        window.clearInterval(clearInter)
        this.isCheckBtnDisable = false
        this.codeContent = '获取验证码'
        this.totalTime = 120
      }
    }, 1000)
  }
  private validatePass (value) {
    if (!value || !isPassword(value)) {
      return false
    } else {
      if (value.length < 6) {
        return false
      } else {
        return true
      }
    }
  }
  private validateUsername(value) {
    if (!value) {
      return false
    } else if (!isMobile(value) && !isEmail(value)) {
      return false
    } else {
      return true
    }
  }
  private handleResetPwd () {
    console.log('12456')
  }
  private async getCheckCode () {
    if (this.form1.mobilePhone && (isMobile(this.form1.mobilePhone) || isEmail(this.form1.mobilePhone))) {
      // 如果获取验证码正处于倒计时阶段，不允许提交
      if (this.isCheckBtnDisable) {
        return false
      }
      const { mobilePhone } = this.form1
      const res = await getCode({ param: mobilePhone })
      if (res.code === 200) {
        Toast.success({
          duration: 2000,
          message: '验证码发送成功！'
        })
        this.countDown()
        // this.currCode = res.data
      }
    } else {
      Toast.fail({
        duration: 2000,
        message: '请输入正确的手机号！'
      })
    }
  }
  private beforeDestroy () {
    clearInterval(clearInter)
  }
  private async onSubmit () {
    console.log(this.form1)
    let { mobilePhone, verificationCode } = this.form1
    let password = Base64.encode(this.form1.newpassword)
    let res = await resetPwd({ account: mobilePhone, password, verificationCode})
    if (res.code === 200) {
      this.$router.push({ path: '/login' })
    } else {
      this.form1.verificationCode  = ''
    }
  }
}
